import request from '../request';
import { emailAPI } from './urls';
import { config } from '../../utils/config';

export const search = (model) => {
  return request({
    url: emailAPI.search,
    method: 'POST',
    data: model,
    headers: {
      'x-api-key': config.EMAIL_API_KEY,
    },
  })
    .then((response) => response)
    .catch((response) => response);
};

export const getSurveys = (model) => {
  return request({
    url: emailAPI.surveys,
    method: 'GET',
  })
    .then((response) => response)
    .catch((response) => response);
};

const emailService = {
  search,
  getSurveys,
};

export default emailService;
